<div class="layout">
  <div class="form-preview-container">
    <div class="form-preview-container-inner">
      <div class="portal-title">
        <div class="portal-title-left">
          <button (click)="handleBackButton()" class="back-button">
            <span class="back-button-icon" [innerHTML]="arrowIcon"></span>
          </button>
          <div class="portal-title-template">
            <span class="portal-title-template-subtitle" i18n>Template name</span>
            <h1 class="portal-title-template-title">{{labInfo?.title ?? ''}}</h1>
          </div>
        </div>
        <div class="portal-title-right">
          <button class="save-button" (click)="handleSaveTemplateButtonClicked()">
            <span [innerHTML]="saveIcon"></span>
            <span class="save-button-text" i18n>Save template</span>
          </button>
        </div>
      </div>
      <div class="preview">
        <lib-gallery
          #gallery
          [showLogo]="false"
          [showTitle]="true"
          [labInfo]="labInfo"
          [createForm]="createForm()"
          [generatedContent]="generatedContent" />
      </div>
    </div>
  </div>
  <div class="form-container">
    @if (labInfo && builderConfigId) {
      <lib-form
        [urlHash]="builderConfigId"
        [instantHost]="instantHost"
        [labInfo]="labInfo"
        [manageLocked]="true"
        [portal]="true"
        [tenantId]="me?.tenant?.id ?? null"
        [parameters]="parameters"
        [previewToken]="previewJwt"
        (createForm$)="setCreateForm($event)"
        (generatedContent$)="handleGeneratedContentUpdated($event)"
        (labInfoChanged)="labInfoUpdated($event)" />
    }
  </div>
</div>
